import { isAdultStudentByDateOfBirth } from './enrollmentGuardian';

/** Normalize email for academy-scoped student identity matching. */
export function normalizeStarterRequestEmail(email: string): string {
  return email.trim().toLowerCase();
}

/** Normalize person name for academy-scoped student identity matching. */
export function normalizeStarterRequestName(name: string): string {
  return name.trim().replace(/\s+/g, ' ').toLowerCase();
}

/** Parse YYYY-MM-DD to a UTC date-only value for exact DOB comparison. */
export function parseStarterRequestDateOfBirth(value: string): Date | null {
  const trimmed = value.trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return null;
  const date = new Date(`${trimmed}T12:00:00.000Z`);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function formatStarterRequestDateOfBirth(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function starterRequestRequiresGuardian(dateOfBirth: string): boolean {
  const parsed = parseStarterRequestDateOfBirth(dateOfBirth);
  if (!parsed) return true;
  return !isAdultStudentByDateOfBirth(parsed);
}
